import { render, staticRenderFns } from "./SideDrawerNotes.vue?vue&type=template&id=6a933038&"
import script from "./SideDrawerNotes.vue?vue&type=script&lang=js&"
export * from "./SideDrawerNotes.vue?vue&type=script&lang=js&"
import style0 from "./SideDrawerNotes.vue?vue&type=style&index=0&id=6a933038&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports